/* unplugin-vue-components disabled */import { render } from "./SideModalButton.vue?vue&type=template&id=76d65506&scoped=true"
import script from "./SideModalButton.vue?vue&type=script&lang=js"
export * from "./SideModalButton.vue?vue&type=script&lang=js"

import "./SideModalButton.vue?vue&type=style&index=0&id=76d65506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d65506"]])

export default __exports__